import React, { useEffect, useState } from "react";
import { getSecureUser } from "../utils/secureStorage";
import Logo from "../assests/NIGST LOGO Jan 24.png";
import "../CSS/app.css";
import ViewCourses from "./ViewCourses";
import ViewEnrolledCourse from "./ViewEnrolledCourse";
import ViewCanceledCourse from "./ViewCanceledCourse";
import { Button } from "@mui/material";
import axios from "axios";

export default function Student() {
  const [activeTab, setActiveTab] = useState("courses"); // 'courses' | 'enrolled' | 'cancelled'
  const [user, setUser] = useState({});

  useEffect(() => {
    const storedUser = getSecureUser();
    if (storedUser) {
      setUser(storedUser);
    }
  }, []);

  const logout = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/logout`,
        {},
        { withCredentials: true }
      );
      if (response.status === 200) {
        console.log("Logout successful.");
        localStorage.clear();
        window.location.hash = "/";
      }
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case "courses":
        return <ViewCourses />;
      case "enrolled":
        return <ViewEnrolledCourse />;
      case "cancelled":
        return <ViewCanceledCourse />;
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      {/* Header */}
      <header className="flex items-center justify-between h-32 py-4 bg-white border-b border-gray-200">
        {/* Left (Welcome) */}
        <div className="h-32 w-2/12 flex items-center justify-center bg-[#1050A2]">
          <h1 className="text-white font-bold">Welcome, {user.name}</h1>
        </div>

        {/* Right (Logo & Logout) */}
        <div className="w-10/12 flex items-center justify-evenly relative h-full">
          <img src={Logo} alt="NIGST Logo" className="h-full object-contain" />
          <Button
            onClick={logout}
            variant="contained"
            sx={{ position: "absolute", right: 10, top: 20 }}
          >
            Logout
          </Button>
        </div>
      </header>

      {/* Layout Body */}
      <div className="flex flex-1">
        {/* Sidebar */}
        <aside className="w-2/12 bg-[#1050A2] text-white">
          <nav>
            <ul className=" space-y-2">
              <li
                className={`p-3 cursor-pointer ${activeTab === "courses" ? "bg-yellow-400 text-black" : ""
                  }`}
                onClick={() => setActiveTab("courses")}
              >
                Courses
              </li>
              <li
                className={`p-3 cursor-pointer ${activeTab === "enrolled" ? "bg-yellow-400 text-black" : ""
                  }`}
                onClick={() => setActiveTab("enrolled")}
              >
                Enrolled Courses
              </li>
              <li
                className={`p-3 cursor-pointer ${activeTab === "cancelled" ? "bg-yellow-400 text-black" : ""
                  }`}
                onClick={() => setActiveTab("cancelled")}
              >
                Cancelled Enrolled Courses
              </li>
            </ul>
          </nav>
        </aside>

        {/* Main Content */}
        <main className="flex-1 w-10/12 p-6 bg-white border-l border-gray-200">
          {renderContent()}
        </main>
      </div>
    </div>

  );
}
